import { csx } from '@vtex/admin-ui'
import React from 'react'
import { useHistory } from 'react-router'
import {
  ProductCarousel,
  ProductCarouselItem,
  ProductCarouselItemTitle,
  ProductCarouselTitle,
  ProductCarouselList,
  ProductCarouselDescription,
  ProductCarouselHeader,
} from '@/checkout-instore-legacy/components/ProductCarousel'

import { SearchImage } from './SearchImage'
import { useFeatureFlag } from '../../../../../../core/hooks'

export type SearchShelfProps = {
  title: string
  description?: string
  items: Array<{
    imageSrc: string
    name: string
    term: string
  }>
}

export const SearchShelf = ({
  title,
  description,
  items,
}: SearchShelfProps) => {
  const history = useHistory()
  const { isNewSearchEnabled } = useFeatureFlag()

  const handleItemClick = (term: string) => () => {
    if (isNewSearchEnabled()) {
      return history.push(`/new-search?term=${term.trim()}`)
    }

    return history.push(`/search?skipDebounce=true&term=${term.trim()}`)
  }

  return (
    <ProductCarousel>
      <ProductCarouselHeader>
        <ProductCarouselTitle>{title}</ProductCarouselTitle>
        <ProductCarouselDescription>{description}</ProductCarouselDescription>
      </ProductCarouselHeader>
      <ProductCarouselList>
        {items.map((item) => (
          <ProductCarouselItem
            key={item.term}
            onClick={handleItemClick(item.term)}
            data-testid="search-shelf-item"
          >
            <SearchImage src={item.imageSrc} alt={item.term} />
            <ProductCarouselItemTitle className={csx({ textAlign: 'center' })}>
              {item.name}
            </ProductCarouselItemTitle>
          </ProductCarouselItem>
        ))}
      </ProductCarouselList>
    </ProductCarousel>
  )
}
